import { Controller } from "stimulus";
import Cookies from "js-cookie";
import { EventPrivacyModeToggled } from "../../events";

export default class extends Controller {
  static targets = ["toggle", "private"];

  connect() {
    if (this._privacyModeOn()) {
      this._setPrivacyModeOn();
    }
  }

  togglePrivacyMode(e) {
    e.preventDefault();

    if (this._privacyModeOn()) {
      this._setPrivacyModeOff();
    } else {
      this._setPrivacyModeOn();
    }
    this.element.dispatchEvent(new CustomEvent(EventPrivacyModeToggled));
  }

  _privacyModeOn() {
    return Cookies.get("portfolioPrivacyMode") === "true"
  }

  _setPrivacyModeOn() {
    this._setPrivacyModeCookie(true);
    this.privateTargets.forEach((elem) => {
      if(elem.dataset.shouldHide === "true") {
        elem.classList.add("tw-hidden")
      } else {
        elem.classList.remove("tw-hidden")
      }
    })
    this.toggleTarget.classList.remove("fa-eye");
    this.toggleTarget.classList.add("fa-eye-slash");
  }

  _setPrivacyModeOff() {
    this._setPrivacyModeCookie(false);
    this.privateTargets.forEach((elem) => {
      if(elem.dataset.shouldHide === "true") {
        elem.classList.remove("tw-hidden")
      } else {
        elem.classList.add("tw-hidden")
      }
    })
    this.toggleTarget.classList.remove("fa-eye-slash");
    this.toggleTarget.classList.add("fa-eye");
  }

  _setPrivacyModeCookie(value) {
    Cookies.set("portfolioPrivacyMode", value, { path: "/" });
  }
}